import { useCallback } from 'react';

import { cx } from '@libs/classnames';
import { DateView } from '@ui/components/DateView';

import { Achievement } from '@features/shared/api/typings';
import { useCertificateTemplateQuery } from '@features/user/api/hooks';
import { formatAchievementPlace } from '@features/user/utils/achievementPlace';

import styles from './PlayerAchievementsListItem.module.css';

type Props = {
  className?: string;
  achievement: Achievement;
  preset: 's' | 'm';
  onClick: (achievement: Achievement) => void;
};

export function PlayerAchievementsListItem({ className, achievement, preset, onClick }: Props) {
  // Тут потом можно будет сделать "Достижения" (медали), а не только "Сертификаты"
  return (
    <CertificatePreviewItem
      className={className}
      preset={preset}
      achievement={achievement}
      onClick={onClick}
    />
  );
}

type CertificatePreviewItemProps = {
  className?: string;
  achievement: Achievement;
  preset: 's' | 'm';
  onClick: (achievement: Achievement) => void;
};
function CertificatePreviewItem({
  className,
  achievement,
  preset,
  onClick,
}: CertificatePreviewItemProps) {
  const handleClick = useCallback(() => {
    onClick(achievement);
  }, [achievement, onClick]);

  const { data: previewTemplate } = useCertificateTemplateQuery(
    achievement.tournamentCertificate?.svgTemplateSrc,
  );

  if (!achievement.tournamentCertificate) return null;

  const place = formatAchievementPlace(achievement.tournamentCertificate.place);

  const generatedCertificate = generateCertificateFromTemplate(
    previewTemplate,
    achievement.tournamentCertificate.fields,
  );

  return (
    <div className={cx(styles.certificatePreview, styles[preset], className)} onClick={handleClick}>
      <div
        className={styles.previewImageContainer}
        dangerouslySetInnerHTML={{ __html: generatedCertificate || '' }}
      />

      <div className={styles.description}>
        <div className={styles.tournament}>
          {achievement.tournamentCertificate?.tournamentTitle}
        </div>
        <div className={styles.title}>{place}</div>
        {preset !== 's' && (
          <div className={styles.date}>
            <DateView date={achievement.receiveTimestampMs} />
          </div>
        )}
      </div>
    </div>
  );
}

function generateCertificateFromTemplate(
  template: string = '',
  fields: Record<string, string> = {},
) {
  let generated = template;

  Object.keys(fields).forEach((field) => {
    generated = generated.replace(`{{${field}}}`, fields[field]!);
  });

  return generated;
}
